function warningSaveDiscardDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/warning-save-discard/warning-save-discard-dialog.html?$$REVISION$$'
  }
}

export { warningSaveDiscardDialog }
